import React, { lazy, Suspense } from 'react'
import { BrowserRouter, Navigate, Route } from 'react-router-dom'
import AppLoading from 'components/common/AppLoading'
import AuthGuard from 'guards/AuthGuard'
import RoutesWithNotFound from './RoutesWithNotFound'
import Private from 'pages/Private'
import AppVersionCheck from 'components/app-version-check/AppVersionCheck'
import { PRIVATE_ROUTES, PUBLIC_ROUTES } from './routes'

const Login = lazy(() => import('pages/login/Login'))

const AppRouter = () => {
  return (
    <Suspense fallback={<AppLoading />}>
      <BrowserRouter>
        <RoutesWithNotFound>
          <Route path="/" element={<Navigate to={PRIVATE_ROUTES.PRIVATE} />} />
          <Route path={PUBLIC_ROUTES.LOGIN} element={<Login />} />
          <Route element={<AuthGuard />}>
            <Route path={`${PRIVATE_ROUTES.PRIVATE}/*`} element={<Private />} />
          </Route>
        </RoutesWithNotFound>

        {/* Va dentro del BrowserRouter porque necesita useLocation para revisar la
            version en cada cambio de ruta. */}
        <AppVersionCheck />
      </BrowserRouter>
    </Suspense>
  )
}

export default AppRouter